<template>
<div class="animated fadeIn mt-5">
  <loading v-if="loading"></loading>
  <form class="has-footer" v-if="!loading" enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <div class="col-md-6">
        <b-tabs>
          <b-tab title="Participante e Família">
            <b-card>
              <div slot="header">
                <strong>Participante</strong>
              </div>
              <modal-select label="Participante" namevar="name" modal="familymembers-modal" v-validate="'required'" name="family_member_id" v-bind:readonly="item.id>0" v-bind:item-id="item.family_member_id" v-bind:item-code="item.familymember.data.code"  v-bind:item-name="item.familymember.data.name" v-on:select-item="selectFamilyMember"  :state="validateState('family_member_id')"  ></modal-select>
              <b-form-invalid-feedback>
                {{ errors.first('activity_id') }}
              </b-form-invalid-feedback>
              <b-form-fieldset label="NIF">
                <b-form-input type="text" name="family_member_nif" v-model="item.familymember.data.nif" placeholder="NIF"  readonly ></b-form-input>
              </b-form-fieldset>
              <b-row>
                <b-col>
                  <b-form-fieldset label="Email">
                    <b-form-input type="text" name="family_member_email" v-model="item.familymember.data.email" placeholder="Email"  readonly ></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col>
                  <b-form-fieldset label="Telefone">
                    <b-form-input type="text" name="family_member_phone" v-model="item.familymember.data.phone" placeholder="Telefone"  readonly ></b-form-input>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-form-row>
                <b-col md="4">
                  <b-form-fieldset label="NIF">
                    <b-form-input type="text" readonly name="nif" v-model="item.familymember.data.nif" placeholder="NIF" ></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col md="4">
                  <b-form-fieldset label="Data de Nascimento">
                    <b-form-input type="date" readonly name="birth_date" v-model="item.familymember.data.birth_date" placeholder="Data de Nascimento" ></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col md="4">
                  <b-form-fieldset label="Sexo">
                    <b-form-select disabled  v-model="item.familymember.data.gender" name="gender" class="mb-3">
                      <template v-slot:first>
                       <b-form-select-option :value="null" >-- escolha uma opção --</b-form-select-option>
                     </template>
                      <option value="1">Masculino</option>
                      <option value="2">Feminino</option>
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-form-row>

            </b-card>

            <b-card>
              <div slot="header">
                <strong>Família</strong>
              </div>
              <b-form-row>
                <b-col md="3">
                  <b-form-fieldset label="Código">
                    <b-form-input type="text" name="id" readonly v-model="item.family.data.id" placeholder="Código" ></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col md="9">
                  <b-form-fieldset label="Apelido">
                    <b-form-input type="text" name="surname" readonly v-model="item.family.data.surname" placeholder="Apelido"  ></b-form-input>
                  </b-form-fieldset>
                </b-col>
              </b-form-row>
              <b-row>
                <b-col>
                  <b-form-fieldset label="Estado">
                    <b-form-select name="state" v-model="item.family.data.state" disabled readonly class="mb-3">
                      <option value="0">Inactivo</option>
                      <option value="1">Activo</option>
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col>
                  <b-form-fieldset label="Ano de inicio">
                    <b-form-input type="text" name="year_started" readonly v-model="item.family.data.year_started" placeholder="Ano de inicio" ></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col>
                  <b-form-fieldset label="Tipo de sócio">
                    <b-form-select name="membership_type_id" readonly disabled v-model="item.family.data.membership_type_id"   :options="membershiptypes" class="mb-3">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-form-fieldset label="Email">
                <b-form-input type="email" readonly name="email" v-model="item.family.data.email" placeholder="Email"  ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('email') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset label="Telefone">
                <b-form-input type="text" readonly name="phone" v-model="item.family.data.phone" placeholder="Telefone" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('phone') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-fieldset label="Morada">
                <b-form-input type="text" readonly name="address" v-model="item.family.data.address" placeholder="Morada" ></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('address') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
              <b-form-row>
                <b-col md="4">
                  <b-form-fieldset label="Código Postal">
                    <b-form-input type="text" readonly name="zip_code" v-model="item.family.data.zip_code" placeholder="Código Postal"></b-form-input>
                    <b-form-invalid-feedback>
                      {{ errors.first('zip_code') }}
                    </b-form-invalid-feedback>
                  </b-form-fieldset>
                </b-col>
                <b-col md="8">
                  <b-form-fieldset label="Localidade">
                    <b-form-input type="text" readonly name="locality" v-model="item.family.data.locality" placeholder="Localidade" ></b-form-input>
                    <b-form-invalid-feedback>
                      {{ errors.first('locality') }}
                    </b-form-invalid-feedback>
                  </b-form-fieldset>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col md="4">
                  <b-form-fieldset label="País">
                    <b-form-select disabled readonly v-model="item.family.data.country_id" :options="countries" class="mb-3">
                      <template v-slot:first>
                       <b-form-select-option :value="null" >-- escolha um país --</b-form-select-option>
                     </template>
                    </b-form-select>
                    <b-form-invalid-feedback>
                      {{ errors.first('country_id') }}
                    </b-form-invalid-feedback>
                  </b-form-fieldset>
                </b-col>
                <b-col md="8">
                  <b-form-fieldset  label="Código de Zona">
                    <b-form-select readonly disabled v-model="item.family.data.region_id" :options="regions" class="mb-3">
                      <template v-slot:first>
                       <b-form-select-option :value="null" >-- Automático --</b-form-select-option>
                     </template>
                    </b-form-select>
                    <b-form-invalid-feedback>
                      {{ errors.first('region_id') }}
                    </b-form-invalid-feedback>
                  </b-form-fieldset>
                </b-col>
              </b-form-row>

              <b-form-fieldset label="Notas / Observações">
                <b-form-textarea readonly type="text" :rows="10" name="notes" v-model="item.family.data.notes" placeholder="Notas / Observações" :state="validateState('notes')" data-vv-validate-on="change" ></b-form-textarea>
                <b-form-invalid-feedback>
                  {{ errors.first('notes') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-card>
          </b-tab>
          <b-tab title="Histórico participante">
            <b-table striped hover :items="item.familymember.data.history.data" :fields="historyFields">
              <template v-slot:cell(state)="data">
                {{ states.translate(data.value, 'historyStates') }}
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Alterações">
            <audits :audits="auditlog"></audits>
          </b-tab>
        </b-tabs>
      </div>
      <!--/.col-->
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Dados da inscrição</strong>
          </div>
          <b-row>
            <b-col md="8">
              <modal-select label="Escalão" namevar="name" modal="activities-modal" v-validate="'required'" name="activity_id" v-bind:readonly="item.id>0" v-bind:item-id="item.activity_id" v-bind:item-code="item.activity.data.code"  v-bind:item-name="item.activity.data.name" v-on:select-item="selectActivity"  :state="validateState('activity_id')"  ></modal-select>
              <b-form-invalid-feedback>
                {{ errors.first('activity_id') }}
              </b-form-invalid-feedback>
            </b-col>
            <b-col md="4">
              <b-form-fieldset label="SubEscalão">
                <b-form-select v-model="item.subactivity_id"  v-on:change="changedSubactivity" :options="filteredSubs"  name="subactivity_id" class="mb-3" >
                  <template v-slot:first>
                   <b-form-select-option :value="null" > -- Não colocado -- </b-form-select-option>
                 </template>
                </b-form-select>
                <b-form-invalid-feedback>
                  {{ errors.first('subactivity_id') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <div>
            <h5>Preferências</h5>
            <b-row>
              <b-col md="6">
                <h6>Escolhidas</h6>
                <ol>
                  <li v-for="(sub, index) in item.preferences" :key="index">{{ sub.name }}
                    <a v-if="index > 0" href="#" @click.prevent="moveUp(index)"><i class="fa fa-arrow-up"></i></a>
                    <a v-if="item.preferences.length !== (index-1)" href="#" @click.prevent="moveDown(index)"><i class="fa fa-arrow-down"></i></a>
                    <a href="#" @click.prevent="removePref(index)"><i class="fa fa-times"></i></a>
                  </li>
                </ol>
              </b-col>
              <b-col md="6">
                <h6>Não escolhidas</h6>
                <ul>
                  <li v-for="(sub, index) in item.not_chosen" :key="index">{{ sub.name }} <a href="#" @click.prevent="addPref(index)"><i class="fa fa-plus"></i></a></li>
                </ul>
              </b-col>
            </b-row>
          </div>
          <b-form-fieldset label="Ranking">
            <b-form-input type="text" name="ranking" v-model="item.ranking" placeholder="Ranking"  :state="validateState('ranking')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('ranking') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-row>
            <b-col>
              <b-form-fieldset label="Estado">
                <b-form-select v-model="item.state" class="mb-3" :options="states.registrationStates">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col>
              <b-form-fieldset label="Lista de Espera">
                <b-form-select v-model="item.onhold" v-on:change="changedOnHold" class="mb-3" :options="states.yesNo">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col>
              <b-form-fieldset label="Fora do prazo">
                <b-form-select v-model="item.out_of_time"  class="mb-3" :options="states.yesNo">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col >
              <b-form-fieldset label="Mostrar resultado">
                <b-form-select v-model="item.show_result" class="mb-3" :options="states.yesNo">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-fieldset label="Distribuido">
                <b-form-select v-model="item.distributed" class="mb-3" :options="states.yesNo">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col>
              <b-form-fieldset label="Não voltar a distribuir">
                <b-form-select v-model="item.distribution_locked" class="mb-3" :options="states.yesNo">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-fieldset label="Interesse confirmado">
                <b-form-select v-model="item.interest_confirmed" class="mb-3" :options="states.yesNo">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
            <b-col>
              <b-form-fieldset label="Data limite de confirmação do interesse">
                <b-form-input type="date" name="interest_max_date" v-model="item.interest_max_date" placeholder="Data limite"  :state="validateState('interest_max_date')"></b-form-input>
              </b-form-fieldset>
            </b-col>

          </b-row>
          <b-form-fieldset label="Data da inscrição">
            <b-form-input type="text" name="created_at" v-model="item.created_at" placeholder="Data da inscrição"  readonly :state="validateState('created_at')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('code') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>

           <b-form-fieldset label="Notas / Observações">
                <b-form-textarea type="text" :rows="10" name="reg_notes" v-model="item.notes" placeholder="Notas / Observações"  ></b-form-textarea>
              </b-form-fieldset>
        </b-card>
        <b-card>
          <div slot="header">
            <strong>Dados de pagamento</strong>
          </div>
          <b-row>
            <b-col>
              <b-form-fieldset label="Estado do pagamento">
                <b-form-select v-model="item.paid" class="mb-3" :options="states.registrationStates">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-fieldset label="Valor da Escalão">
                <b-form-input type="number" name="activity_price" v-model="item.activity_price" placeholder="Valor da Escalão"  :state="validateState('activity_price')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('activity_price') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col>
              <b-form-fieldset label="Valor Solidário">
                <b-form-input type="number" name="solidary_value" v-model="item.solidary_value" placeholder="Valor Solidário"  :state="validateState('solidary_value')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('solidary_value') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
            <b-col>
              <b-form-fieldset label="Total">
                <b-form-input type="number" name="total" v-model="item.total" placeholder="Total"  readonly :state="validateState('total')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('total') }}
                </b-form-invalid-feedback>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <h6>Referências Multibanco</h6>
          <b-row>
            <b-col md="6">
              <b-form-fieldset description="Caso existam, as referências atuais irão ser canceladas e criadas novas referências" label="Gerar novas referências">
                <b-form-select v-model="generateMB" :options="states.yesNo" class="mb-3">
                </b-form-select>
              </b-form-fieldset>
            </b-col>
          </b-row>
          <b-table striped hover :items="item.references.data" :fields="referencesFields">
            <template v-slot:cell(state)="data">
              {{ states.translate(data.value, 'referenceStates') }}
            </template>
          </b-table>
        </b-card>
      </div>
      <!--/.col-->
    </div>
    <footer class="page-footer">
      <div class="text-right">
        <a class="btn btn-link" target="_blank" :href="axios.defaults.baseURL + 'preview_registration_email/' + item.id" size="sm"><i class="fa fa-envelope-o"></i> Pré-visualizar email</a>
        <router-link class="btn btn-link" :to="{name:baseRoute + '.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>
        <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
        <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
      </div>
    </footer>
  </form>

</div>
</template>

<script>
import States from '@/components/Lists.js'
export default {
  name: 'registrationsEdit',
  props: ['id'],
  data() {
    return {
      url: 'registrations',
      baseRoute: 'registrations',
      loading: true,
      showTeam: false,
      showPassword: false,
      generateMB: 0,
      auditlog: [],
      subactivities: [],
      countries: [],
      regions: [],
      membershiptypes: [],
      states: States,
      item: {
        family_member_id: null,
        activity_year_id: null,
        subactivity_id: null,
        activity_id: null,
        preferences: [],
        not_chosen: [],
        state: 0,
        archived: 0,
        onhold: 0,
        distributed: 0,
        distribution_locked: 0,
        show_result: 0,
        veteran: 0,
        ranking: 0,
        interest_confirmed: 0,
        activity_price: 0,
        solidary_value: 0,
        total: 0,
        paid: 0,
        paid_at: null,
        notes: '',
        interest_max_date: null,
        activity: {
          data: {}
        },
        references: {
          data: []
        },
        familymember: {
          data: {
            history: {
              data: []
            }
          }
        },
        family: { data: {} }
      },
      historyFields: [{
        key: 'activity.data.name',
        label: 'Escalão',
        sortable: true
      }, {
        key: 'year.data.activity_year',
        label: 'Ano',
        sortable: true
      }, {
        key: 'state',
        label: 'Estado',
        sortable: true
      }],
      referencesFields: [{
        key: 'state',
        label: 'Estado',
        sortable: true
      }, {
        key: 'entity',
        label: 'Entidade',
        sortable: true
      }, {
        key: 'reference',
        label: 'Referência',
        sortable: true
      }, {
        key: 'value',
        label: 'Valor',
        sortable: true
      }, {
        key: 'expiration_date',
        label: 'Data limite',
        sortable: true
      }]
    }
  },
  computed: {
    filteredSubs() {
      return this.subactivities.filter(subactivity => subactivity.parent_id === this.item.activity_id);
    }
  },
  methods: {
    changedSubactivity(e) {
      console.log(e)
      if(this.item.subactivity_id) {
        this.item.onhold = 0
      } else {
        this.item.onhold = 1
      }
    },
    changedOnHold(e) {
      console.log(e)
      if(this.item.onhold == 1) {
        this.item.subactivity_id = null
      }
    },
    selectActivity(e) {
      if(e.item) {
        console.log(e.item)
        this.item.activity_id = e.item.id
        this.item.activity.data = e.item
      } else {
        this.item.activity_id = null
        this.item.activity.data = {id: null, name:null}
      }
    },
    selectFamilyMember(e) {
      if(e.item) {
        console.log(e.item)
        this.item.family_member_id = e.item.id
        this.item.familymember.data = e.item
      } else {
        this.item.family_member_id = null
        this.item.familymember.data = {id: null, surname:null}
      }
    },
    removePref(index) {
      let item = this.item.preferences[index]
      this.item.not_chosen.push(item)
      this.item.preferences.splice(index,1)
    },
    addPref(index) {
      let item = this.item.not_chosen[index]
      this.item.preferences.push(item)
      this.item.not_chosen.splice(index,1)
    },
    moveUp(index) {
      this.item.preferences.move(index, index-1)
    },
    moveDown(index) {
      this.item.preferences.move(index, index+1)
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast('Tem campos inválidos', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      data.generateMB = this.generateMB
      if (this.item.id) {
        this.axios.put(this.url + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.auditlog = response.data.meta.audits
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            if (close) {
              this.$router.push({
                name: this.baseRoute + '.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      } else {
        this.axios.post(this.url, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast('item gravado com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
            this.$router.push({
              name: this.baseRoute + '.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast('Não foi possivel gravar', { autoHideDelay: 5000, variant: 'danger', solid: true})
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get(this.url + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.auditlog = response.data.meta.audits
          this.loading = false
        })
        .catch(response => {
          this.$bvToast.toast('Esta inscrição não existe', { autoHideDelay: 5000, variant: 'danger', solid: true})
          this.$router.push({
            name: this.baseRoute + '.index'
          })
        })
    } else {
      this.loading = false
    }

    this.axios.get('subactivities/lst').then(response => {
      this.subactivities = response.data.data
    })


    this.axios.get('countries/lst').then(response => {
      this.countries = response.data.data
    })
    this.axios.get('regions/lst').then(response => {
      this.regions = response.data.data
    })
    this.axios.get('membershiptypes/lst').then(response => {
      this.membershiptypes = response.data.data
    })
  }
}
</script>
